import React from 'react';
import { Bookmark, Trash2, ArrowRight } from 'lucide-react';
import Button from '../../../../../components/ui/Button';

/**
 * Компонент боковой панели для сохраненных конфигураций
 */
const SavedConfigsSidebar = ({ 
  savedConfigs, 
  deleteConfig, 
  loadConfig 
}) => {
  // Если нет сохраненных конфигураций
  if (!savedConfigs || savedConfigs.length === 0) {
    return (
      <div className="bg-white dark:bg-gray-800 rounded-xl border border-gray-200 dark:border-gray-700 p-5 shadow-sm">
        <h3 className="text-lg font-medium text-gray-900 dark:text-white mb-4 flex items-center">
          <Bookmark className="w-5 h-5 mr-2 text-indigo-500" />
          Сохраненные настройки
        </h3>
        <p className="text-sm text-gray-600 dark:text-gray-400">
          Здесь будут отображаться сохраненные настройки генератора для быстрого доступа.
        </p>
      </div>
    );
  }

  return (
    <div className="bg-white dark:bg-gray-800 rounded-xl border border-gray-200 dark:border-gray-700 p-5 shadow-sm">
      <div className="flex justify-between items-center mb-4">
        <h3 className="text-lg font-medium text-gray-900 dark:text-white flex items-center">
          <Bookmark className="w-5 h-5 mr-2 text-indigo-500" />
          Сохраненные настройки
        </h3>
        <span className="text-sm text-gray-500 dark:text-gray-400">
          {savedConfigs.length}
        </span>
      </div>

      <div className="space-y-4">
        {savedConfigs.map((config) => (
          <div 
            key={config.id} 
            className="bg-gray-50 dark:bg-gray-700/30 border border-gray-200 dark:border-gray-700 rounded-lg p-4 hover:bg-gray-100 dark:hover:bg-gray-700 transition-colors"
          >
            <div className="flex justify-between items-start mb-2">
              <h4 className="text-sm font-medium text-gray-900 dark:text-white">
                {config.name}
              </h4>
              <div className="flex items-center space-x-2">
                <Button
                  size="xs"
                  variant="ghost"
                  onClick={() => loadConfig(config.id)}
                  title="Загрузить настройки"
                  icon={<ArrowRight className="w-4 h-4" />}
                />
                <Button
                  size="xs"
                  variant="ghost"
                  onClick={() => deleteConfig(config.id)}
                  title="Удалить"
                  icon={<Trash2 className="w-4 h-4 text-red-500" />}
                />
              </div>
            </div>
            
            <div className="text-xs text-gray-600 dark:text-gray-400">
              <div className="flex justify-between mb-1">
                <span>Диапазон:</span>
                <span className="font-medium">
                  {config.config.customRange 
                    ? 'Пользовательский' 
                    : `${config.config.min} - ${config.config.max}`}
                </span>
              </div>
              <div className="flex justify-between mb-1">
                <span>Количество:</span>
                <span>
                  {config.config.count}
                </span>
              </div>
              {config.config.distribution !== 'uniform' && (
                <div className="flex justify-between mb-1">
                  <span>Распределение:</span>
                  <span>
                    {config.config.distribution === 'normal' ? 'Нормальное' : 'Взвешенное'}
                  </span>
                </div>
              )}
              <div className="flex justify-between">
                <span>Уникальные:</span>
                <span>
                  {config.config.unique ? 'Да' : 'Нет'}
                </span>
              </div>
            </div>
            
            {/* Визуальное представление конфигурации */}
            <div className="mt-3 h-2 w-full bg-gray-200 dark:bg-gray-600 rounded-full overflow-hidden">
              <div 
                className="h-full bg-indigo-500 dark:bg-indigo-400 rounded-full"
                style={{ 
                  width: `${Math.min(100, parseInt(config.config.count) * 5)}%`,
                  opacity: 0.7
                }}
              ></div>
            </div>
            
            <div className="mt-2 text-xs text-gray-500 dark:text-gray-400">
              Сохранено: {new Date(config.date).toLocaleDateString('ru-RU')}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default SavedConfigsSidebar;